export const GENRE_OPTIONS = [
  "Fiction",
  "Nonfiction",
  "Comics/Manga",
  "Children",
  "Mystery",
  "Romance",
  "Self-help",
];
